





























































































































































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions } from 'ag-grid-community'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import { PersonalDispositionRequirement, QcqCommonGridItem, WorkFormData } from '@/types'
import {
  ASSIGN_EMPLOYEE_TO_DISPOSITION_JOB, END_DISPOSITION_JOB, FETCH_DISPOSITION_WEEK_PERIOD_LIST,
  FIND_PERSON_FOR_DISPOSITION_JOB,
  GET_DISPOSITION_JOB_DATA,
  LOAD_COMPETENCE,
  SAVE_DISPOSITION_JOB_DATA, SET_DISPOSITION_JOB_STATUS_LIST, UPDATE_DISPOSITION_JOB_PERSON_LIST
} from '@/store/action-types'
import { Competence } from '@/model/qcq/Competence'
import CompetenceDialog from '@/components/disposition/CompetenceDialog.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import TextAreaCellRenderer from '@/components/cell-renderer/TextAreaCellRenderer.vue'
import ArrayCellRenderer from '@/components/cell-renderer/ArrayCellRenderer.vue'
import SelectedEmployeeCellRenderer from '@/components/cell-renderer/SelectedEmployeeCellRenderer.vue'
import SelectCellRenderer from '@/components/cell-renderer/SelectCellRenderer.vue'
import { DispositionJobPayload, FindPersonDispoJobPayload } from '@/types/payload'
import { DispositionJob } from '@/model/disposition/DispositionJob'
import { DispositionJobDetail } from '@/model/disposition/DispositionJobDetail'
import { DispositionAddress } from '@/model/disposition/DispositionAddress'
import WarningDialog from '@/components/WarningDialog.vue'
import { DispositionJobEmployee } from '@/model/disposition/DispositionJobEmployee'
import { GET_DISPOSITION_DEFAULT_DISTANCE } from '@/store/getter-types'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { WorkRhythm } from '@/model/disposition/WorkRhythm'
import WhatsAppCellRenderer from '@/components/cell-renderer/WhatsAppCellRenderer.vue'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  inSaveProgress: boolean
  inRecalculateSaveProgress: boolean
  inAssignSaveProgress: boolean
  inFinishSaveProgress: boolean
  inSaveTableProgress: boolean
  personalDispositionJobDetailId: number | undefined
  gridData: Array<QcqCommonGridItem>
  gridDataResponse: Array<QcqCommonGridItem>
  gridOptions: GridOptions
  overlayNoRowsTemplate: string
  competenceList: Array<QcqCommonGridItem>
  showDialog: boolean
  showDeleteDialog: boolean
  showWarningDialog: boolean
  suitableEmployees: DispositionJobEmployee[]
  suitableEmployeesGridOptions: GridOptions
  defaultColDef: Object
  gridFrameworkComponents: Object
  title: string
  validationRules: Array<Function>
  basicHoursValidationRules: Array<Function>
  address: number| undefined
  workRhythm: number | undefined
  workRhythmList: WorkRhythm[]
  workFormData: WorkFormData[]
  basicHours: string | undefined
  additionalHours: string | undefined
  totalHours: string | undefined
  selectedCompetenceId: number | undefined
  selectedCompetenceData: QcqCommonGridItem | undefined
  employeeInDistance: string
  referenceDate: string | null
  dispositionJobDetail: DispositionJobDetail | undefined
  isAssignedPerson: boolean
  isReadOnly: boolean
  loading: boolean
}

export default Vue.extend({
  name: 'AllocationDialog',

  components: {
    AgGridVue,
    CompetenceDialog,
    DeleteDialog,
    WarningDialog,
    ProgressCircular
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    dialogData: Object as () => DispositionJob | undefined,
    addressList: Array as () => DispositionAddress[],
    dispositionAddress: Number
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.addresses.required').toString()
    const basicHoursRule = (value: any): boolean | string => (!!value && value > 0) || this.$t('masterData.addresses.required').toString()

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      inSaveProgress: false,
      inRecalculateSaveProgress: false,
      inAssignSaveProgress: false,
      inFinishSaveProgress: false,
      inSaveTableProgress: false,
      personalDispositionJobDetailId: undefined,
      gridData: [],
      gridDataResponse: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('employeeFormComponent.qcq.description').toString(), field: 'description' },
        ]
      },
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      competenceList: [],
      showDialog: false,
      showDeleteDialog: false,
      showWarningDialog: false,
      suitableEmployees: [],
      suitableEmployeesGridOptions: {
        columnDefs: [
          { headerName: this.$t('disposition.employee').toString(), field: 'employee', width: 210, cellRenderer: 'selectedEmployeeCellRenderer'},
          { headerName: this.$t('disposition.status').toString(), field: 'status', width: 150, cellRenderer: 'selectCellRenderer'},
          {
            headerName: this.$t('planningPage.monday').toString(),
            children: [
              { headerName: this.$t('disposition.vm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[0].morning ? 'X' : ''
                }
              },
              { headerName: this.$t('disposition.nm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[0].afternoon ? 'X' : ''
                }
              }
            ]
          },
          {
            headerName: this.$t('planningPage.tuesday').toString(),
            children: [
              { headerName: this.$t('disposition.vm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[1].morning ? 'X' : ''
                }
              },
              { headerName: this.$t('disposition.nm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[1].afternoon ? 'X' : ''
                }
              }
            ]
          },
          {
            headerName: this.$t('planningPage.wednesday').toString(),
            children: [
              { headerName: this.$t('disposition.vm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[2].morning ? 'X' : ''
                }
              },
              { headerName: this.$t('disposition.nm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[2].afternoon ? 'X' : ''
                }
              }
            ]
          },
          {
            headerName: this.$t('planningPage.thursday').toString(),
            children: [
              { headerName: this.$t('disposition.vm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[3].morning ? 'X' : ''
                }
              },
              { headerName: this.$t('disposition.nm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[3].afternoon ? 'X' : ''
                }
              }
            ]
          },
          {
            headerName: this.$t('planningPage.friday').toString(),
            children: [
              { headerName: this.$t('disposition.vm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[4].morning ? 'X' : ''
                }
              },
              { headerName: this.$t('disposition.nm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[4].afternoon ? 'X' : ''
                }
              }
            ]
          },
          {
            headerName: this.$t('planningPage.saturday').toString(),
            children: [
              { headerName: this.$t('disposition.vm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[5].morning ? 'X' : ''
                }
              },
              { headerName: this.$t('disposition.nm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[5].afternoon ? 'X' : ''
                }
              }
            ]
          },
          { headerName: this.$t('disposition.distance').toString(), field: 'distance', width: 80 },
          { headerName: this.$t('disposition.placeOfResidence').toString(), field: 'placeOfResidence', width: 170},
          {headerName: this.$t('disposition.contact').toString(),
            children: [
              {  width: 60,
                cellRenderer:'whatsAppCellRenderer'
              },
              { headerName: this.$t('disposition.mobile').toString(), field: 'mobile', width: 110,
                cellRenderer: function(params) {
                  return `<a href="tel:${params.data.mobile}"> ${params.data.mobile} </a>`
                }
              },
              { headerName: this.$t('disposition.email').toString(), field: 'email', width: 150,
                cellRenderer: function(params) {
                  return `<a href="mailto:${params.data.email}"> ${params.data.email} </a>`
                }
              }
            ]
          },
          {headerName: this.$t('disposition.competence').toString(), field: 'competence', width: 190, cellRenderer: 'arrayCellRenderer' },
          {headerName: this.$t('disposition.note').toString(), field: 'note', cellRenderer:'textAreaCellRenderer'},
        ]
      },
      defaultColDef: {
        wrapText: true,
        autoHeight: true
      },
      gridFrameworkComponents: {
        selectedEmployeeCellRenderer: SelectedEmployeeCellRenderer,
        selectCellRenderer: SelectCellRenderer,
        arrayCellRenderer: ArrayCellRenderer,
        textAreaCellRenderer: TextAreaCellRenderer,
        whatsAppCellRenderer: WhatsAppCellRenderer
      },
      title: '',
      validationRules: [required],
      basicHoursValidationRules: [basicHoursRule],
      address: undefined,
      workRhythm: undefined,
      workRhythmList: [],
      workFormData: [
        {dayNumber: 1, dayLabel: this.$t('planningPage.monday').toString(), morning: false, afternoon: false, priority: ''},
        {dayNumber: 2, dayLabel: this.$t('planningPage.tuesday').toString(), morning: false, afternoon: false, priority: ''},
        {dayNumber: 3, dayLabel: this.$t('planningPage.wednesday').toString(), morning: false, afternoon: false, priority: ''},
        {dayNumber: 4, dayLabel: this.$t('planningPage.thursday').toString(), morning: false, afternoon: false, priority: ''},
        {dayNumber: 5, dayLabel: this.$t('planningPage.friday').toString(), morning: false, afternoon: false, priority: ''},
        {dayNumber: 6, dayLabel: this.$t('planningPage.saturday').toString(), morning: false, afternoon: false, priority: ''},
        {dayNumber: 7, dayLabel: this.$t('planningPage.sunday').toString(), morning: false, afternoon: false, priority: ''}
      ],
      basicHours: undefined,
      additionalHours: undefined,
      totalHours: undefined,
      selectedCompetenceId: undefined,
      selectedCompetenceData: undefined,
      employeeInDistance: '0',
      referenceDate: null,
      dispositionJobDetail: undefined,
      isAssignedPerson: false,
      isReadOnly: false,
      loading: false
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isEnableCompetenceButtons (): boolean {
      if(this.selectedCompetenceData && !this.isReadOnly && !this.isAssignedPerson) {
        return true
      } else {
        return false
      }
    },

    isCancelButtonDisabled (): boolean {
      if(this.inSaveProgress || this.inRecalculateSaveProgress || this.inAssignSaveProgress || this.inFinishSaveProgress || this.inSaveTableProgress) {
        return true
      } else {
        return false
      }
    },

    isRecalculateButtonDisabled (): boolean {
      return !(this.personalDispositionJobDetailId && this.suitableEmployees.length === 0 && this.isFormSaveDisabled)
    },

    isAssignmentButtonEnabled (): boolean {
      if(this.personalDispositionJobDetailId && this.suitableEmployees.length !== 0) {
        const foundEmployee: DispositionJobEmployee | undefined = this.suitableEmployees.find((item: DispositionJobEmployee) => item.status === 5)
        if(foundEmployee && this.isFormSaveDisabled  && this.isPersonSaveDisabled && !this.isAssignedPerson && !this.isReadOnly) {
          return true
        } else {
          return false
        }
      }
      return false
    },

    isEndButtonEnabled (): boolean {
      return this.isAssignedPerson && !this.isReadOnly
    },

    isFormSaveDisabled (): boolean {
      if(this.dispositionJobDetail) {

        const isBasicHours: boolean = this.dispositionJobDetail!.basicHours ? parseFloat(this.dispositionJobDetail!.basicHours!.toString()).toFixed(2).toString() !== this.basicHours : this.dispositionJobDetail!.basicHours  !== this.basicHours
        const isAdditionalHours: boolean = this.dispositionJobDetail!.additionalHours ? parseFloat(this.dispositionJobDetail!.additionalHours!.toString()).toFixed(2).toString() !== this.additionalHours : this.dispositionJobDetail!.additionalHours !== this.additionalHours

        if ((this.dispositionJobDetail.address !== this.address ||
            this.dispositionJobDetail.workRhythm !== this.workRhythm ||
            JSON.stringify(this.dispositionJobDetail.workFormData) !== JSON.stringify(this.workFormData) ||
            isBasicHours||
            isAdditionalHours||
            parseFloat(this.dispositionJobDetail!.totalHours!.toString()).toFixed(2).toString() !== this.totalHours ||
            JSON.stringify(_.orderBy(this.gridDataResponse, ['id'],['asc'])) !== JSON.stringify(_.orderBy(this.gridData, ['id'],['asc'])) ||
            this.dispositionJobDetail.employeeInDistance !== this.employeeInDistance) && !this.isAssignedPerson
            ) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },

    isPersonSaveDisabled (): boolean {
      if(this.dispositionJobDetail && this.dispositionJobDetail.dispositionJobEmployeeList && !this.isAssignedPerson) {
        if(JSON.stringify(this.dispositionJobDetail.dispositionJobEmployeeList) !== JSON.stringify(this.suitableEmployees)) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    }

  },

  methods: {
    onBasicHoursChange (): void {
      if(this.basicHours) {
        this.basicHours = parseFloat(this.basicHours).toFixed(2).toString()
        if(this.additionalHours) {
          this.totalHours = parseFloat((Math.round((parseFloat(this.basicHours) + parseFloat(this.additionalHours)) * 100) / 100).toString()).toFixed(2).toString()
        } else {
          this.totalHours = this.basicHours
        }
      } else {
        if(this.additionalHours) {
          this.totalHours = this.additionalHours
        } else {
          this.totalHours = undefined
        }
      }
    },

    onAdditionalHoursChange (): void {
      if(this.additionalHours) {
        this.additionalHours = parseFloat(this.additionalHours).toFixed(2).toString()
        if(this.basicHours) {
          this.totalHours = parseFloat((Math.round((parseFloat(this.additionalHours) + parseFloat(this.basicHours)) * 100) / 100).toString()).toFixed(2).toString()
        } else {
          this.totalHours = this.additionalHours
        }
      } else {
        if(this.basicHours) {
          this.totalHours = this.basicHours
        } else {
          this.totalHours = undefined
        }
      }
    },

    onRowClicked (params: any): void {
      this.selectedCompetenceId = params.data.id
      const foundCompetence = this.gridData.find((item: QcqCommonGridItem) => item.id === this!.selectedCompetenceId)
      if(foundCompetence) {
        this.selectedCompetenceData = foundCompetence
      }
    },

    onAddCompetenceClick (): void {
      this.selectedCompetenceId = undefined
      this.selectedCompetenceData = undefined
      this.showDialog = true
    },

    onEditCompetenceButtonClick (): void {
      this.showDialog = true
    },

    dialogSaved (payload: QcqCommonGridItem): void {
      if(this.selectedCompetenceData) {
        const index: number = this.gridData.indexOf(this.selectedCompetenceData)
        this.gridData.splice(index, 1, payload)
        this.showDialog = false
      } else {
        this.gridData.push(payload)
        this.showDialog = false
      }
      this.selectedCompetenceId = undefined
      this.selectedCompetenceData = undefined
    },

    closeDialog (): void {
      this.showDialog = false
    },

    onDeleteCompetenceButtonClick (): void {
      this.showDeleteDialog = true
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      if(this.selectedCompetenceData) {
        const index: number = this.gridData.indexOf(this.selectedCompetenceData)
        this.gridData.splice(index, 1)
        this.showDeleteDialog = true
      }
      this.showDeleteDialog = false
      this.selectedCompetenceId = undefined
      this.selectedCompetenceData = undefined
    },

    onWarningDialogClose (): void {
      this.showWarningDialog = false
    },

    onWarningDialogSave (): void {
      this.savePersonalDispositionDetail()
    },


    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        if(this.suitableEmployees.length > 0) {
          this.showWarningDialog = true
        } else {
          this.savePersonalDispositionDetail()
        }
      }
    },

    async savePersonalDispositionDetail (): Promise<void> {
      this.inSaveProgress = true

      const payload: DispositionJobPayload = {
        id: this.personalDispositionJobDetailId ? this.personalDispositionJobDetailId : null,
        address: this.address!,
        workRhythm: this.workRhythm!.toString(),
        workFormData: this.workFormData,
        referenceDate: this.referenceDate,
        basicHours: this.basicHours!,
        additionalHours: this.additionalHours!,
        totalHours: this.totalHours!,
        employeeInDistance: parseInt(this.employeeInDistance!),
        requirements: this.gridData,
        reallocation: false,
        action: this.personalDispositionJobDetailId ? 'Update' : 'Insert'
      }

      try {
        const response: number = await this.$store.dispatch(SAVE_DISPOSITION_JOB_DATA, payload)
        if(response) {
          if(payload.action === 'Insert') {
            this.personalDispositionJobDetailId = response
          } else {
            this.onWarningDialogClose()
          }
          this.fetchData(this.personalDispositionJobDetailId!)
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inSaveProgress = false
      }
    },

    onFindPersonClick (): void {
      this.findPersonForDispositionJob()
    },

    async findPersonForDispositionJob (): Promise<void> {
      this.inRecalculateSaveProgress = true
      const payload: FindPersonDispoJobPayload = {
        id: this.personalDispositionJobDetailId!,
        reAllocation: false
      }

      try {
        const response: boolean = await this.$store.dispatch(FIND_PERSON_FOR_DISPOSITION_JOB, payload)
        if(response) {
          this.fetchData(this.personalDispositionJobDetailId!)
        }
      } catch {
      } finally {
        this.inRecalculateSaveProgress = false
      }
    },

    onAssignEmployeeClick (): void {
      this.assignEmployeeToDispositionJob()
    },

    async assignEmployeeToDispositionJob (): Promise<void> {
      this.inAssignSaveProgress = true
      try {
        const response: boolean = await this.$store.dispatch(ASSIGN_EMPLOYEE_TO_DISPOSITION_JOB, this.personalDispositionJobDetailId!)
        if(response) {
          this.isAssignedPerson = true
          this.fetchData(this.personalDispositionJobDetailId!)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inAssignSaveProgress = false
      }
    },

    onEndDispositionJobClick (): void {
      this.endDispositionJob()
    },

    async endDispositionJob (): Promise<void> {
      this.inFinishSaveProgress = true
      try {
        const response: boolean = await this.$store.dispatch(END_DISPOSITION_JOB, this.personalDispositionJobDetailId!)
        if(response) {
          this.$emit('fetchAddress')
          this.isReadOnly = true
          this.fetchData(this.personalDispositionJobDetailId!)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inFinishSaveProgress = false
      }
    },

    onPersonSaveButtonClick (): void {
      this.updateDispositionJobPersonList()
    },

    async updateDispositionJobPersonList (): Promise<void> {
      this.inSaveTableProgress = true

      try {
        const response: boolean = await this.$store.dispatch(UPDATE_DISPOSITION_JOB_PERSON_LIST, this.suitableEmployees)
        if(response) {
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchData(this.personalDispositionJobDetailId!)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inSaveTableProgress = false
      }
    },

    async fetchWeekPeriodList (): Promise<void> {
      this.workRhythmList = await this.$store.dispatch(FETCH_DISPOSITION_WEEK_PERIOD_LIST)
    },

    async fetchCompetenceList (): Promise<void> {
      this.$store.dispatch(LOAD_COMPETENCE, 1)
          .then((data: Array<Competence>) => {
            data.forEach((item: Competence) => {
              this.competenceList.push(item.commonGridData)
            })
            if(this.dispositionJobDetail) {
              this.dispositionJobDetail.requirements.forEach((item: PersonalDispositionRequirement) => {
                const foundItem: QcqCommonGridItem | undefined = this.competenceList.find((i: QcqCommonGridItem) => i.id === item.competence)
                if(foundItem) {
                  this.gridData.push(foundItem)
                }
              })
              this.gridDataResponse = _.cloneDeep(this.gridData)
            }
          })
    },

    async fetchData (id: number): Promise<void> {
      this.loading = true
      try {
        const response: DispositionJobDetail | undefined = await this.$store.dispatch(GET_DISPOSITION_JOB_DATA, id)
        if(response) {
          this.dispositionJobDetail = _.cloneDeep(response)
          this.address = response.address ? response.address : undefined
          this.workRhythm = response.workRhythm
          this.workFormData = response.workFormData
          this.referenceDate = response.referenceDate ? response.referenceDate : null
          this.basicHours = response.basicHours
          this.additionalHours = response.additionalHours
          this.totalHours = response.totalHours
          this.employeeInDistance = response.employeeInDistance
          this.gridData = []
          response.requirements.forEach((item: PersonalDispositionRequirement) => {
            const foundItem: QcqCommonGridItem | undefined = this.competenceList.find((i: QcqCommonGridItem) => i.id === item.competence)
            if(foundItem) {
              this.gridData.push(foundItem)
            }
          })
          this.gridDataResponse = _.cloneDeep(this.gridData)
          if(response.statusList) {
            this.$store.dispatch(SET_DISPOSITION_JOB_STATUS_LIST, response.statusList)
          }
          this.suitableEmployees = response.dispositionJobEmployeeList
        }
      } catch {

      } finally {
        this.loading = false
      }
    }
  },

  mounted (): void {
    this.employeeInDistance = this.$store.getters[GET_DISPOSITION_DEFAULT_DISTANCE].toString()
    this.fetchWeekPeriodList()
    this.fetchCompetenceList()
    if(this.dialogData && this.dialogData.personalDispositionJobDetailId) {
      this.isAssignedPerson = this.dialogData.status === 2
      this.isReadOnly = this.dialogData.status === 3
      this.title = this.$t('menu.allocation').toString()
      this.personalDispositionJobDetailId = this.dialogData.personalDispositionJobDetailId
      this.fetchData(this.dialogData.personalDispositionJobDetailId)

    } else {
      this.title = this.$t('menu.allocation').toString()
      if(this.dispositionAddress) {
        this.address = this.dispositionAddress
      }
    }
  }
})
